import * as React from "react";

function SvgNotification() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15.281" style={{ marginTop: '-3px' }} fill='#284672 ' viewBox="0 0 15 18.281">
            <path id="Icon_material-notifications" data-name="Icon material-notifications" d="M13.5,22.031a1.881,1.881,0,0,0,1.875-1.875h-3.75A1.874,1.874,0,0,0,13.5,22.031Zm5.625-5.625V11.719c0-2.878-1.537-5.287-4.219-5.925V5.156a1.406,1.406,0,0,0-2.813,0v.638C9.4,6.431,7.875,8.831,7.875,11.719v4.688L6,18.281v.937H21v-.937Z" transform="translate(-6 -3.75)" fill="#284672 " />
        </svg>
    )
}
export default SvgNotification;


// WEBPACK FOOTER //
// ./src/iconComponents/notificationsIcon.js